export function getObjectOpacity(z, baseOpacity) {
  if (z === undefined) return baseOpacity;
  const maxZ = 500;
  const minZ = -500;
  const normalizedZ = Math.max(minZ, Math.min(maxZ, z));
  const opacityFactor = 1 - (normalizedZ - minZ) / (maxZ - minZ) * 0.5;
  return baseOpacity * opacityFactor;
}

export function getPlayerColor(player) {
  if (player.side === 'CT') {
    return player.isBlinded ? '#a0b4ff' : '#687cca';
  } if (player.side === 'T') {
    return player.isBlinded ? '#ffb366' : '#e38617';
  }
  return '#ffffff';
}

export function getBombColor(bombState, bombPlantEvent, currentTick) {
  if (!bombPlantEvent) return '#ff6b6b';

  const plantTick = bombPlantEvent.tick || 0;
  const timeSincePlant = (currentTick - plantTick) / 64;

  if (timeSincePlant < 5) {
    return '#ff6b6b';
  } if (timeSincePlant < 35) {
    return '#ffa500';
  }
  return '#ff0000';
}

export function getTimeOfTick(tick, roundStartTick = 0, tickRate = 64) {
  return (tick - roundStartTick) / tickRate;
}
